import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { ClaimDocumentsPartialState } from './claim-documents.reducer';
import { ClaimDocumentForm } from './claim-documents.models';
import { claimDocumentsQuery } from './claim-documents.selectors';
import {
  LoadClaimOwnerDocuments,
  SaveClaimDocumentInformation,
  UpdateClaimDocumentInformation
} from './claim-documents.actions';
import { Parameter } from '@ecosure-suite/shared/utils-helpers';

@Injectable({
  providedIn: 'root'
})
export class ClaimDocumentsFacade {
  loaded$ = this.store.pipe(select(claimDocumentsQuery.getLoaded));
  loading$ = this.store.pipe(select(claimDocumentsQuery.getLoading));
  allClaimDocuments$ = this.store.pipe(
    select(claimDocumentsQuery.getAllClaimDocuments)
  );
  selectedClaimDocument$ = this.store.pipe(
    select(claimDocumentsQuery.getSelectedClaimDocument)
  );
  selectedClaimOwners$ = this.store.pipe(
    select(claimDocumentsQuery.getClaimOwners)
  );

  constructor(private store: Store<ClaimDocumentsPartialState>) {}

  loadAllByOwner(owner: Parameter) {
    this.store.dispatch(new LoadClaimOwnerDocuments(owner));
  }

  upload(document: ClaimDocumentForm) {
    this.store.dispatch(new SaveClaimDocumentInformation(document));
  }

  editUpload(document: ClaimDocumentForm) {
    this.store.dispatch(new UpdateClaimDocumentInformation(document));
  }
}
